import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  height: 100vh; /* FIXED FULL SCREEN */
  background: #f3f4f6;
  overflow: hidden; /* NO PAGE SCROLL */
`;

export const MainContainerLeft = styled.div`
  width: 250px;
  background: #ffffff;
  border-right: 1px solid #e5e7eb;
`;

export const MainContainerRight = styled.div`
  flex: 1;
  padding: 0px 15px;
  overflow-y: auto; /* SCROLL ONLY RIGHT SIDE */
`;
